<div class="lang-dropdown">
    <button type="button"
            class="lang-trigger"
            aria-haspopup="true"
            aria-controls="lang-menu"
            [attr.aria-expanded]="isOpen()"
            [attr.aria-label]="('select_country' | T) + ': ' + current().name"
            (click)="toggle()">
        <img class="flag" [src]="current().img" alt="" width="18" height="18">
    </button>

    @if (isOpen()) {
        <ul id="lang-menu" class="lang-menu">
            @for (c of countries; track c.id) {
                <li>
                    <a class="lang-option"
                       [href]="c.route"
                       [attr.aria-current]="c.id === selectedId() ? 'true' : null">
                        <img class="flag" [src]="c.img" alt="" width="18" height="18">
                        <span class="lang-option-text">{{ c.name }}</span>
                    </a>
                </li>
            }
        </ul>
        <button type="button" class="lang-backdrop" tabindex="-1" aria-hidden="true" (click)="close()"></button>
    }
</div>
